import { render } from "./Crowdsale.vue?vue&type=template&id=1c31bc72"
import script from "./Crowdsale.vue?vue&type=script&lang=js"
export * from "./Crowdsale.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__